import axios from "axios";

const APIHelper = {
  // Customers
  listCustomers: async (token, { page = 1, limit = 20, search = "" } = {}) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/customers`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search },
      }
    );
    return response.data;
  },

  // WhatsApp
  getWhatsAppConfig: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/whatsapp/config`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.config;
  },

  // Shipping Settings
  getShippingSettings: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/settings`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.settings;
  },

  updateShippingSettings: async (token, body) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/settings`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Products
  listProducts: async (
    token,
    {
      q = "",
      status = "All",
      page = 1,
      limit = 20,
      sortBy = "createdAt",
      sortDir = "desc",
    } = {}
  ) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/products`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { q, status, page, limit, sortBy, sortDir },
      }
    );
    return response.data;
  },
  createProduct: async (token, body) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/products`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  updateProduct: async (token, id, body) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/products/${id}`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  deleteProduct: async (token, id) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/products/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  updateWhatsAppConfig: async (token, body) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/whatsapp/config`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  getWhatsAppTemplates: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/whatsapp/templates`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.templates || [];
  },
  sendWhatsAppTest: async (token, { to, template }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/whatsapp/messages/send`,
      { to, template },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  broadcastWhatsApp: async (token, { template, onlyOptedIn = false }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/whatsapp/messages/broadcast`,
      { template, onlyOptedIn },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  createCustomer: async (token, body) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/customers`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  updateCustomer: async (token, id, body) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/customers/${id}`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  deleteCustomer: async (token, id) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/customers/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  fetchPreferredPage: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/user/preferred-page`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.preferredPage;
  },

  updatePreferredPage: async (token, preferredPage) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/user/preferred-page`,
      { preferredPage },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  clearPreferredPage: async (token) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/user/preferred-page`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  fetchAutoCommentConfig: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/user/auto-comment-config`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.autoCommentConfig;
  },

  updateAutoCommentConfig: async (token, autoCommentConfig) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/user/auto-comment-config`,
      autoCommentConfig,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  clearAutoCommentConfig: async (token) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/user/auto-comment-config`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  fetchMediaAutoCommentConfig: async (token, mediaId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/media/auto-comment-config?mediaId=${mediaId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.autoCommentConfig;
  },

  updateMediaAutoCommentConfig: async (token, mediaId, autoCommentConfig) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/media/auto-comment-config?mediaId=${mediaId}`,
      autoCommentConfig,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },
  suggestKeywords: async (token, { context, postId }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/ai/suggest-keywords`,
      { context, postId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.keywords || [];
  },
  // ===== CHECKOUT ENDPOINTS (NEW REUSABLE SYSTEM) =====
  
  createProductCheckout: async (
    token,
    { postId, buttonIndex, amount, productName, pageId, productSku }
  ) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/checkout/product/create?pageId=${pageId}`,
      { postId, buttonIndex, amount, productName, productSku },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // ===== SHIPPING ENDPOINTS (ZIPPY INTEGRATION) =====

  checkServiceability: async (token, orderId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/check-serviceability/${orderId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  getQuickQuote: async (token, orderId, packageData = {}) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/quick-quote/${orderId}`,
      packageData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  generateShippingLabel: async (token, orderId, packageData = {}) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/generate-label/${orderId}`,
      packageData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  trackShipment: async (token, orderId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/track/${orderId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  getShipmentDetails: async (token, orderId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/shipment/${orderId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  cancelShipment: async (token, orderId) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/cancel/${orderId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  customShipment: async (token, orderId, { carrier, trackingNumber, trackingUrl }) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/shipping/custom-ship/${orderId}`,
      { carrier, trackingNumber, trackingUrl },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // ===== LEGACY PAYMENT LINK ENDPOINTS (DEPRECATED) =====
  
  createPaymentLink: async (
    token,
    { postId, buttonIndex, amount, productName, pageId }
  ) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/payment-link/create?pageId=${pageId}`,
      { postId, buttonIndex, amount, productName },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  getPaymentLink: async (token, postId, buttonIndex, pageId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/payment-link/${postId}/${buttonIndex}?pageId=${pageId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  listOrders: async (
    token,
    { pageId, status, search, page = 1, limit = 10 }
  ) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/orders`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { pageId, status, search, page, limit },
      }
    );
    return response.data;
  },
  getOrder: async (token, orderId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.order;
  },
  updateOrderStatus: async (token, orderId, status) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}/status`,
      { status },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },
  getPaymentDetails: async (token, orderId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}/payment-details`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.payment;
  },

  clearMediaAutoCommentConfig: async (token, mediaId) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/media/auto-comment-config?mediaId=${mediaId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  disconnectFacebook: async (token) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/disconnect-facebook`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  },

  uploadImageToCloudinary: async (file) => {
    // Detect if file is a video or image
    const isVideo = file.type?.startsWith("video/");
    const uploadType = isVideo ? "video" : "image";
    const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}/${uploadType}/upload`;
    const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

    if (!file) {
      throw new Error("No file provided for upload");
    }

    if (isVideo && file.size > 100 * 1024 * 1024) {
      throw new Error("Video file size exceeds the 100MB limit. Please upload a smaller video.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    try {
      const response = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.error?.message ||
            `Failed to upload ${uploadType} to Cloudinary`
        );
      }

      const data = await response.json();
      return data; // Returns the full response from Cloudinary
    } catch (error) {
      console.error(`Error uploading ${uploadType} to Cloudinary:`, error);
      throw error;
    }
  },

  // Finance
  getBalance: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/finance/balance`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  getPayoutHistory: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/finance/payout-history`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  requestPayout: async (token, amount) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/finance/request-payout`,
      { amount },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  retryPayout: async (token, requestId) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/finance/retry-payout/${requestId}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Settings - Bank Details
  getBankDetails: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/settings/bank-details`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  updateBankDetails: async (token, bankDetails) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/settings/bank-details`,
      bankDetails,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Campaigns
  listCampaigns: async (token, params = {}) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/campaigns/list`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response.data;
  },

  createCampaign: async (token, body) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/campaigns/create`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  updateCampaign: async (token, id, body) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/campaigns/${id}`,
      body,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  getCampaignDetails: async (token, id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/campaigns/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  getCampaignStats: async (token, id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/campaigns/${id}/stats`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  // Campaign Checkout
  getCampaignProductDetails: async (campaignId) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/checkout/campaign/${campaignId}/details`
    );
    return response.data;
  },

  createCampaignOrder: async (campaignId, quantity = 1) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/checkout/campaign/create-order`,
      { campaignId, quantity }
    );
    return response.data;
  },

  // Managed Pages
  getManagedPages: async (token) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/user/managed-pages`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data.managedPages;
  },

  addManagedPage: async (token, pageId) => {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/user/managed-pages`,
      { pageId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  },

  removeManagedPage: async (token, pageId) => {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/user/managed-pages`,
      { 
        headers: { Authorization: `Bearer ${token}` },
        data: { pageId }
      }
    );
    return response.data;
  },
};

export default APIHelper;
